import { Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import { isValid } from "date-fns";
import { FC, useEffect, useState } from "react";
import { FaCreditCard } from "react-icons/fa";
import { CARTAO_CREDITO, DEAFULT_CARTAO } from "src/constants";
import { Formater, TypeRecords } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import { InputMoney } from "src/framework/components/forms";
import { confirmationDialog, notifierStore } from "src/framework/store";
import { CartaoCreditoParcelaType, CartaoCreditoType, CartaoType, PagamentoCartaoType, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { CartaoCredito } from "../../cartao/CartaoCredito";
import { FormaPagamentoIcons } from "../FormaPagamento/FormaPagamentoIcons";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";
import { CardCartaoCredito } from "./CardCartaoCredito";

import "./styles.scss";

interface CartaoAPrazoProperties {
    onIsValid: (isValid: boolean) => void;
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType) => void;
    pedido: PedidoType | null;
    qtdCartoes: number;
    qtdParcelas?: number;
}

const CartaoAPrazo: FC<CartaoAPrazoProperties> = ({
    pedido,
    onConfirmar,
    onIsValid,
    qtdCartoes,
    qtdParcelas
}) => {

    const [pagamentoCartaoState, setPagamentoCartaoState] = useState<CartaoCreditoType & PagamentoCartaoType>(DEAFULT_CARTAO);
    const [pagamentoCartaoState2, setPagamentoCartaoState2] = useState<CartaoCreditoType & PagamentoCartaoType | null>(null);
    const [disabled, setDisabled] = useState<boolean>(false);
    const [valorPendente, setValorPendente] = useState<number | null>(null);
    const [valorResidual, setValorResidual] = useState<number | null>(null);
    const [cartoesCredito, setCartoesCredito] = useState<Array<CartaoCreditoType & PagamentoCartaoType>>([]);
    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const [cartaoEdicao, setCartaoEdicao] = useState<number>(-1);

    const _valorPendente = (): number | null => {
        if (pedido) {
            let valorEmPagamento: number = 0
            const valores: number[] = cartoesCredito.map(c => c.valor_original)
            for (const valor of valores) {
                valorEmPagamento += valor
            }
            return Number(((pedido?.valor_pendente || pedido?.valor_pagamento) - valorEmPagamento).toFixed(2))
        }
        return null;
    }

    const _isValid = () => {
        return !(pagamentoCartaoState.cvc === "" || (pagamentoCartaoState?.cvc as string)?.length < 3 || pagamentoCartaoState.expiry === "" || pagamentoCartaoState.name === "" || pagamentoCartaoState.number === "" || pagamentoCartaoState.parcela === null || pagamentoCartaoState.issuer === "" || pagamentoCartaoState.issuer === "unknow" || !pagamentoCartaoState.is_valid)
    }

    useEffect(() => {
        const state: CartaoCreditoType & PagamentoCartaoType = { ...pagamentoCartaoState }
        state.codigo_venda = pedido?.codigo_venda;
        state.valor_original = Number(pedido?.valor_pendente || "0")
        setPagamentoCartaoState(state)
        if (pagamentoCartaoState2) {
            const state2: CartaoCreditoType & PagamentoCartaoType = { ...pagamentoCartaoState2 }
            state2.codigo_venda = pedido?.codigo_venda;
            setPagamentoCartaoState2(state2)
        }
    }, []);

    useEffect(() => {
        const _valor = _valorPendente();
        if (_valor !== null) {
            setValorPendente(Number(_valor))
            setValorResidual(Number(_valor))
        }

    }, [cartoesCredito])
    const handleKeyUp = (event: any) => {
        if(event.key === 'Escape'){
            setOpenDialog(false);
        }
    }

    return <div className="CartaoAPrazo">
        <div className="row">
            <div className="X12">

              <HeaderFormaPagamento 
                    icon={<><FaCreditCard /></>}
                    title={<>Cartão de crédito</>}
                    subTitle={`Você pode pagar com até ${qtdCartoes === 1 ? " 1 cartão." : " " + qtdCartoes + " cartões"}. Digite o valor a pagar:`}
              />
                
            </div>
            <div className="X12">
                {cartoesCredito.map((newValue, index) => {
                    const cartao: CartaoType & { parcela?: CartaoCreditoParcelaType | null } = {
                        numero: newValue?.number?.replace(/\s/g, ""),
                        bandeira: newValue.issuer,
                        valor: newValue?.parcela ? newValue.parcela.total : Number((newValue.parcelas * newValue.valor_parcela).toFixed(2)),
                        nome: newValue.name,
                        cvv: newValue.cvc,
                        mes_expiracao: Number(newValue.expiry.split("/")[0]),
                        ano_expiracao: Number(newValue.expiry.split("/")[1]),
                        parcelas: newValue.parcelas,
                        valor_original: newValue.valor_original,
                        parcela: newValue.parcela,
                        valor_parcela: newValue.valor_parcela,

                    }

                    return <CardCartaoCredito
                        key={`cartao-${cartao.numero}`}
                        cartao={cartao}
                        onEdit={() => {
                            const state: CartaoCreditoType & PagamentoCartaoType = { ...pagamentoCartaoState }

                            state.codigo_venda = pedido?.codigo_venda;
                            state.valor_original = Number(cartao?.valor_original || "0")
                            state.cvc = cartao.cvv
                            state.expiry = `${cartao.mes_expiracao}/${cartao.ano_expiracao}`
                            state.issuer = cartao.bandeira
                            state.name = cartao.nome
                            state.number = cartao.numero
                            state.parcelas = cartao.parcelas
                            state.parcela = cartao.parcela
                            state.valor_original = cartao.valor_original
                            state.valor_parcela = cartao.valor
                            state.is_valid = !!cartao.parcela

                            setPagamentoCartaoState(state)
                            setCartaoEdicao(index)
                            setOpenDialog(true);
                        }}
                        onRemove={() => {
                            confirmationDialog.setup({
                                title: "Aviso",
                                content: "Remover este cartão de crédito?",
                                onClose: () => {
                                    confirmationDialog.close()
                                },
                                onConfirmation: () => {
                                    const _cartoesCredito: any[] = [...cartoesCredito]
                                    _cartoesCredito.splice(index, 1)
                                    setCartoesCredito(_cartoesCredito)
                                    confirmationDialog.close()

                                }
                            })
                            confirmationDialog.open()
                        }}
                    />
                })}
                
            </div>
        </div>
        <div className="row">

            
            {valorPendente !== null && valorPendente > 0 && <div className="X12 S6 M4">

                <InputMoney 
                    label="Valor residual"
                    value={valorResidual}
                    disabled={!valorPendente || (cartoesCredito.length + 1 === qtdCartoes)}
                    onChangeValue={(newValue) => {
                        let _valor = newValue?.numberValue; 
                        setValorResidual(Number(_valor))
                    }}
                    onBlur={(event: any) => {
                        let _valor: number = Number(Number(String(event?.target?.value || "0,00")?.replace(/\./g, "")?.replace(/\,/g, ".")).toFixed(2)); 
                        if (_valor && _valor > valorPendente || (_valor < valorPendente && cartoesCredito.length > 0)) {
                            _valor = valorPendente;
                        }
                        setValorResidual(Number(_valor))
                    }}

                />
            </div>}
            
        </div>
        
        <div className="row">
            <div className="X12 S6 M4 L3 M--offset4 L--offset6">
                <br />
                <FullWidthButton
                    text={`Adicionar ${cartoesCredito.length > 0 ? "outro ": ""}cartão`}
                    variant="contained"
                    disableElevation
                    disabled={(!valorPendente || !valorResidual)}
                    color="secondary"
                    onClick={() => {
                        if (valorResidual !== null) {
                            const state: CartaoCreditoType & PagamentoCartaoType = { ...pagamentoCartaoState }
                            state.codigo_venda = pedido?.codigo_venda;
                            state.is_valid = false;
                            state.valor_original = valorResidual
                            setPagamentoCartaoState(state)
                            setOpenDialog(true);
                        }
                    }}
                />

            </div>
            <div className="X12 S6 M4 L3">
                <br />
                <FullWidthButton
                    text="Confirmar"
                    variant="contained"
                    disableElevation
                    disabled={!(valorPendente === 0)}
                    color="primary"
                    onClick={() => {
                        if (pedido) {
                            const messages: string[] = [];
                            const listaCartoes: CartaoType[] = [];

                            for (const cartaoCredito of cartoesCredito) {
                                const _cartao: CartaoType = {
                                    numero: cartaoCredito?.number?.replace(/\s/g, ""),
                                    bandeira: cartaoCredito.issuer,
                                    valor: cartaoCredito?.parcela ? cartaoCredito.parcela.total : Number((cartaoCredito.parcelas * cartaoCredito.valor_parcela).toFixed(2)),
                                    nome: cartaoCredito.name,
                                    cvv: cartaoCredito.cvc,
                                    mes_expiracao: Number(cartaoCredito.expiry.split("/")[0]),
                                    ano_expiracao: Number(cartaoCredito.expiry.split("/")[1]),
                                    parcelas: cartaoCredito.parcelas,
                                    valor_original: cartaoCredito.valor_original,
                                    valor_parcela: cartaoCredito.valor_parcela
                                }
                                listaCartoes.push(_cartao)
                            }

                            if (messages.length > 0) {
                                notifierStore.setNotifier({
                                    title: "Aviso!!",
                                    content: messages,
                                    timeOut: 2500,
                                    onClose: () => {
                                        notifierStore.setOpen(false);
                                    }
                                })
                                notifierStore.setOpen(true);
                                return;
                            }

                            if (messages.length === 0) {

                                const pedidoPagamento: PedidoPagamento = {
                                    forma_pagamento: CARTAO_CREDITO.id,
                                    pedido: pedido?.id,
                                    itens: {
                                        cartoes_credito: listaCartoes
                                    }
                                }
                                onConfirmar(pedidoPagamento, CARTAO_CREDITO.id as any)
                                setDisabled(true)
                            }

                        }
                    }}
                />
            </div>
        </div>
        {/* EDIÇÃO DE CARTÕES */}
        <Dialog className={"dialog-edit-cartao"} open={openDialog} maxWidth="lg" onKeyUp={handleKeyUp}>
            <DialogTitle>
            </DialogTitle>
            <DialogContent>
                <CartaoCredito
                    pagamentoCartao={pagamentoCartaoState}
                    entrada={false}
                    solo={false}
                    onChange={(newValue) => {
                        setPagamentoCartaoState(newValue)
                    }}
                    onConfirmar={() => { }}
                    disabledValoPargamento={true}
                />
            </DialogContent>
            <DialogActions>
                <div className="row actions">
                    <div className="X12 M4">
                        <FullWidthButton 
                            text="Fechar"
                            onClick={()=>{
                                setOpenDialog(false);
                            }}
                        />
                    </div>
                    <div className="X12 M4">                        
                        <FullWidthButton
                            text="Cancelar"
                            onClick={() => {
                                setOpenDialog(false);
                                setPagamentoCartaoState({ ...DEAFULT_CARTAO, codigo_venda: pedido?.codigo_venda, })
                            }}
                        />
                    </div>
                    <div className="X12 M4">
                        <FullWidthButton
                            text={`Salvar`}
                            variant="contained"
                            color="primary"
                            disableElevation
                            disabled={disabled || !_isValid()}
                            onClick={() => {
                                if (pedido) {
                                    const newValue = pagamentoCartaoState;
                                    const _cartoes = [...cartoesCredito]

                                    if (cartaoEdicao > -1) {
                                        _cartoes[cartaoEdicao] = newValue;
                                    } else {
                                        const recorrencia = _cartoes.filter((c) => c.number === newValue.number)

                                        if (recorrencia.length > 0) {
                                            notifierStore.setNotifier({
                                                title: "Aviso!!!",
                                                content: `Cartão com final ${String(newValue.number).slice(-4)} já foi informado anteriormente. Tente um outro cartão!`,
                                                onClose: () => notifierStore.setOpen(false),
                                                timeOut: 2500
                                            })
                                            notifierStore.setOpen(true);
                                            return;
                                        }

                                        _cartoes.push(newValue)
                                    }
                                    setCartoesCredito(_cartoes)
                                }

                                setOpenDialog(false);
                                setPagamentoCartaoState({ ...DEAFULT_CARTAO });
                                setCartaoEdicao(-1)
                            }}
                        />
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    </div>
}

export { CartaoAPrazo } 